import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  menuRoot: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  },
  mobileMenu: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  input: {
    boxShadow: theme.palette.shadow.cardBoxShadow,
    backgroundColor: theme.palette.common.white,
    borderRadius: '8px',
    padding: '1rem',
    width: '100%',
    '&>div': {
      '&::before': {
        borderBottom: 'none !important',
      },
      '&::after': {
        borderBottom: 'none !important',
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  selectArrow: {
    color: theme.palette.blue.main,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menuItem: {
    padding: '1rem',
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      fontWeight: 'bold',
      color: theme.palette.common.white,
    },
  },
  selectPaper: {
    paddingLeft: 0,
    borderRadius: '8px',
    '& ul': {
      padding: '0',
    },
    '& li': {
      textTransform: 'capitalize',
    },
  },
}))
